<template>
  <div>
    <Header></Header>
    <div class="content" :style="{
      'margin-left': innerWidth > 1500 ? (innerWidth - 1500) / 2 + 'px' : '0px',
      'height': (innerHeight - 70 - 68) + 'px'
    }">
      <div class="about" style="height: 100%;">
        <img src="../../static/image/about/banner.png" style="width: 1500px;margin-top: 20px;" />
        <div class="commonTitle"
          style="visibility: visible; opacity: 1; transition: all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1);">企业文化</div>

        <div class="content commonContent"
          style="visibility: visible; opacity: 1; transition: all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1);">
          <div class="contentTop">
            <div style="font-weight: 600;font-size: 24px;line-height: 60px;">教育的本质，是一项为成长提供的服务。</div>
            <div style="font-weight: 400;font-size: 16px;line-height: 40px;">这意味着，教学的内容和方式，应该从用户和发展的角度出发。</div>
            <div style="font-weight: 400;font-size: 16px;line-height: 40px;">
              我们的学员，大多是财会行业的从业者。在职业发展中，他们不断寻求能力提升；回归到生活中，他们则又肩负多重责任。帮助他们实现职业技能的高效提升、获得更美好的生活是我们的服务目标。
            </div>
          </div>

          <div class="cultureCard">
            <div class="card">
              <img src="../../static/image/about/icon1.png" style="width: 50px;margin-top: 20px;" />
              <div class="icon_title">品牌主张</div>
              <div class="icon_text">让学习更简单美好</div>
            </div>
            <div class="card">
              <img src="../../static/image/about/icon2.png" style="width: 50px;margin-top: 20px;" />
              <div class="icon_title">使命</div>
              <div class="icon_text">简化学习过程，赋能终身成长，传递美好生活</div>
            </div>
            <div class="card">
              <img src="../../static/image/about/icon3.png" style="width: 50px;margin-top: 20px;" />
              <div class="icon_title">愿景</div>
              <div class="icon_text">构建一个易用、开放的学习生态，激发潜能，共创美好未来</div>
            </div>
            <div class="card">
              <img src="../../static/image/about/icon4.png" style="width: 50px;margin-top: 20px;" />
              <div class="icon_title">价值观</div>
              <div class="icon_text" style="display: grid;grid-template-columns: repeat(2, 1fr);">
                <div class="fl">求真务实</div>
                <div class="fl">开放创新</div>
                <div class="fl">简约高效</div>
                <div class="fl">互信共赢</div>
              </div>
            </div>
          </div>

        </div>


        <div class="commonTitle"
          style="visibility: visible; opacity: 1; transition: all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1);">企业大事记</div>
          <img src="../../static/image/about/corporate_history.png" style="width: 100%;margin-top: 20px;" />

        <div class="commonTitle"
          style="visibility: visible; opacity: 1; transition: all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1);">
          产品体系
        </div>
        <div style="height: 300px;">
          <div class="pro_list fl" style="margin-left: 40px;">
            <div class="pro_title">全程班体系</div>
            <div class="courseList" style="display: flex">
              <div class="course">
                <div class="item" v-for="(item, index) in omnigatorList" :key="index">
                  <div class="courseL">
                    <div class="courseImg"></div>
                    <div class="courseName">{{ item.subject }}</div>
                  </div>
                  <div class="courseType">全程班</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pro_list fl " style="margin-left: 80px;">
            <div class="pro_title">VIP私教班体系</div>
            <div class="courseList" style="display: flex">
              <div class="course">
                <div class="item" v-for="(item, index) in omnigatorList" :key="index">
                  <div class="courseL">
                    <div class="courseImg"></div>
                    <div class="courseName">{{ item.subject }}</div>
                  </div>
                  <div class="courseType">私教班</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pro_list fl " style="margin-left: 80px;">
            <div class="pro_title">高效取证班</div>
            <div class="courseList" style="display: flex">
              <div class="course">
                <div class="item" v-for="(item, index) in omnigatorList" :key="index">
                  <div class="courseL">
                    <div class="courseImg"></div>
                    <div class="courseName">{{ item.subject }}</div>
                  </div>
                  <div class="courseType">高效取证班</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="commonTitle"
          style="visibility: visible; clear: both; opacity: 1; transition: all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1);">
          公司分布</div>

        <div class="listBox" >
          <div class="list_left" >
            <div style="border-bottom: 2px solid #F4F5F7;margin-top: 80px;" >
              <div style="" ><span class="el-icon-location-information"></span> 地址</div>
              <div style="margin-top: 20px;margin-bottom: 20px;"  >厦门火炬高新区软件园三期溪西山尾路39号1002室-1单元之一</div>
            </div>
            <div style="border-bottom: 2px solid #F4F5F7;"  >
              <div style="margin-top: 20px;" ><span class="el-icon-message"></span> 邮编</div><br/>
              <div style="margin-bottom: 20px;" >36100</div>
            </div>
            <!-- <div class="item" >
              <div class="title icon3" >电话</div>
              <div class="text" >010-85766604</div>
            </div> -->
          </div> 
          <a
            href="https://map.baidu.com/poi/%E5%8E%A6%E9%97%A8%E6%98%93%E8%BF%87%E6%95%99%E8%82%B2%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@13140642.696043832,2812150.6004185,19.2z?uid=17fd946d89c86ba9f11937da&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&en_uid=17fd946d89c86ba9f11937da&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
            target="_blank" class="list_right" >
            <div class="el-image" >
              <img src="../../static/image/about/map.png"  style="border-radius: 10px;"
                class="el-image__inner">
            </div>
          </a>
        </div>

      </div>
    </div>



    <Suspension></Suspension>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/common/Header"
import Footer from "../components/common/Footer"
import Suspension from "../components/common/Suspension"


export default {
  name: "about",
  components: {
    Header,
    Footer,
    Suspension
  },
  data() {
    return {
      omnigatorList: [
        {
          subject: "初级会计职称",
          rapex: "全程班"
        },
        {
          subject: "中级会计职称",
          rapex: "全程班"
        },
        {
          subject: "税务师",
          rapex: "全程班"
        },
        {
          subject: "建造师",
          rapex: "全程班"
        },
        {
          subject: "社会工作者",
          rapex: "全程班"
        }
      ],

      innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    }
  }
}
</script>
<style scoped>
.commonTitle {
  font-weight: 600;
  font-size: 56px;
  line-height: 60px;
  width: 87.5vw;
  min-width: 1000px;
  max-width: 1680px;
  margin: 0 auto 60px;
  color: #000;
  margin-top: 80px;
}

.cultureCard {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}

.card {
  flex: 1;
  height: 320px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: #FFF;
  padding: 30px;
  color: #000;
  cursor: pointer;
  transition: all .3s;
}

.icon_title {
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  margin-top: 20px;
}

.icon_text {
  margin-top: 20px;
  font-weight: 400;
  font-size: 17px;
  line-height: 32px;

}

.pro_list {
  padding: 30px 30px;
  width: 335px;
  background: #FFFF;
  border-radius: 10px;
}

.pro_title {
  background: linear-gradient(215.81deg, #0dc6eb, #2e6cfd 35.92%, #bc41f9 68.82%, #ffc862 94.08%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  font-size: 28px;
  line-height: 40px;
  margin: 10px 0;
}

.course {
  flex: 1;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  /* padding-left: 30px; */
  margin-left: 30px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.courseImg {
  width: 24px;
  height: 24px;
  background-image: url('../../static/image/about/icon_right.png');
  background-size: 100%;
  margin-right: 2px;
}

.courseL {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.listBox {
    height: 400px;
    background: #FFF;
    padding: 30px 30px 30px 70px;
    border-radius: 20px;
    display: flex;
}
.list_left {
    flex: 1;
    color: #000;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    padding-top: 11px;
}
.list_left .item{
    border-bottom: 2px solid #F4F5F7;
    padding: 32px 0 14px;
}
.list_right{
    flex: 1;
    height: 100%;
    margin-left: 60px;
    border-radius: 20px;
    overflow: hidden;
}
.el-image{
    width: 100%;
    height: 100%;
    transition: transform .3s;
}
</style>